var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mobile-card-full new"
  }, [_c('div', {
    staticClass: "mobile-card-list"
  }, [_c('div', {
    staticClass: "block-header",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.name))]), _c('a', {
    staticClass: "block-header-about",
    attrs: {
      "href": _vm.link
    }
  }, [_vm._v(" Все статьи "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.9467 7.74671C11.9149 7.66488 11.8674 7.59011 11.8067 7.52671L8.47333 4.19338C8.41117 4.13122 8.33738 4.08191 8.25617 4.04827C8.17495 4.01463 8.08791 3.99731 8 3.99731C7.82246 3.99731 7.6522 4.06784 7.52667 4.19338C7.46451 4.25553 7.4152 4.32933 7.38156 4.41054C7.34792 4.49176 7.33061 4.5788 7.33061 4.66671C7.33061 4.84424 7.40113 5.01451 7.52667 5.14004L9.72667 7.33338H4.66667C4.48986 7.33338 4.32029 7.40361 4.19526 7.52864C4.07024 7.65366 4 7.82323 4 8.00004C4 8.17685 4.07024 8.34642 4.19526 8.47145C4.32029 8.59647 4.48986 8.66671 4.66667 8.66671H9.72667L7.52667 10.86C7.46418 10.922 7.41458 10.9958 7.38074 11.077C7.34689 11.1582 7.32947 11.2454 7.32947 11.3334C7.32947 11.4214 7.34689 11.5085 7.38074 11.5898C7.41458 11.671 7.46418 11.7447 7.52667 11.8067C7.58864 11.8692 7.66238 11.9188 7.74361 11.9526C7.82485 11.9865 7.91199 12.0039 8 12.0039C8.08801 12.0039 8.17514 11.9865 8.25638 11.9526C8.33762 11.9188 8.41136 11.8692 8.47333 11.8067L11.8067 8.47338C11.8674 8.40997 11.9149 8.33521 11.9467 8.25338C12.0133 8.09107 12.0133 7.90902 11.9467 7.74671Z",
      "fill": "#6F6F6F"
    }
  })])])]), _c('hr', {
    staticClass: "line"
  }), _c('div', {
    staticClass: "cards-list"
  }, _vm._l(_vm.items.slice(0, -1), function (article) {
    return _c('div', {
      key: '__article-' + _vm.code + '-' + article.id
    }, [_c('a', {
      staticClass: "card-article",
      attrs: {
        "href": article.url
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(article.original_name)
      }
    }), _c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(article.description))])]), _c('img', {
      attrs: {
        "src": article.image
      }
    })]), _c('hr', {
      staticClass: "line"
    })]);
  }), 0)]), _c('ArticleCardMobile', {
    attrs: {
      "article": _vm.items[3]
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }